import type { ReactNode } from "react";
import { Alert, Button, Drawer } from "@/ui";
import { useCanWrite } from "./auth";

export interface FormDrawerProps {
  open: boolean;
  title: ReactNode;
  children: ReactNode;
  /** 提交按钮的文案，写动作本身。 */
  submitLabel?: string;
  saving: boolean;
  /** 接口返回的错误，显示在表单顶部。 */
  error: string | null;
  /** 已保存但后续同步没完成（502）的说明：显示警告，只留关闭按钮，不能再提交。 */
  warning?: string | null;
  onSubmit: () => void;
  onClose: () => void;
  /** 给了时底栏左侧显示“删除”（只给能写的账号），由调用方打开删除确认（D180）。 */
  onDelete?: () => void;
}

/** 主数据的新建与编辑表单都放在右侧抽屉里，底部是取消与提交。 */
export function FormDrawer({ open, title, children, submitLabel = "保存", saving, error, warning, onSubmit, onClose, onDelete }: FormDrawerProps) {
  const canWrite = useCanWrite(); // 只读账号只看不存
  return (
    <Drawer open={open} title={title} onClose={onClose}
      footer={canWrite && !warning ? <>{onDelete && <Button variant="danger" className="ax-foot-start" disabled={saving} onClick={onDelete}>删除</Button>}<Button onClick={onClose}>取消</Button><Button variant="primary" disabled={saving} onClick={onSubmit}>{submitLabel}</Button></> : <Button onClick={onClose}>关闭</Button>}>
      {error && <Alert tone="danger" title="保存失败">{error}</Alert>}
      {warning && <Alert tone="warning" title="已保存，后续同步未完成">{warning}</Alert>}
      {children}
    </Drawer>
  );
}
